import Image from "@components/common/CloudinaryImage";
// import Seo from "@components/common/Seo";
// import SmallBanner from "@components/common/SmallBanner";
import Title from "@components/common/Title";
import Layout from "@components/layouts/Layout";
import Screenshots from "@components/sections/AppScreenshots";
import DownloadApp from "@components/sections/DownloadApp";
// import Testimonials from "@components/sections/LazyTestimonials";
import React from "react";
import TextApp_iCorreos from "./icorreos";
import TextApp_iGC from "./igc";
// import AppContent from "@components/sections/LazyAppContent";
import HeroSection from "@components/newVersion/HeroSection";
import TextApp_iGuB from "./igub";
import TextApp_iMossos from "./imossos";
import TextApp_iPoliciaMadrid from "./ipoliciamadrid";
import TextApp_iSanitarios from "./isanitarios";

const App = (props) => {
    const { pageContext } = props;
    const { item } = pageContext;

    const GetTextApp = () => {
        if (item.name === "icorreos") {
            return TextApp_iCorreos();
        } else if (item.name === "igub") {
            return TextApp_iGuB();
        } else if (item.name === "imossos") {
            return TextApp_iMossos();
        } else if (item.name === "igc") {
            return TextApp_iGC();
        } else if (item.name === "isanitarios") {
            return TextApp_iSanitarios();
        } else if (item.name === "ipoliciamadrid") {
            return TextApp_iPoliciaMadrid();
        } else return null;
    };

    return (
        <Layout
            mode="fixed"
            seo={{
                title: `Aplicación ${item.title}`,
                description: `${item.large_description || item.description}`,
                image: `https://www.iopos.es/images/apps/${item.name}/banner.jpg`,
            }}
        >
            <HeroSection
                filename={`apps/${item.name}/banner`}
                firstTitle={item.title}
                secondTitle={"Diseñado para mejorar tu preparación."}
                thirdTitle={item.description}
                showScrollDownIcon={true}
            />

            <div className="container py-20 lg:px-0">
                <Title className="text-left">
                    ¿Qué es <span className="">{item.title}</span>?
                </Title>

                <GetTextApp />

                <div className="mt-10">
                    <Image
                        tag={`mockup ${item.name}`}
                        className=""
                        filename={`apps/${item.name}/mockup2`}
                    />
                </div>
            </div>

            <DownloadApp
                className="bg-gray-100 bg-opacity-50"
                ios={item.ios_url}
                android={item.android_url}
            />

            {/*<AppContent item={item} className="" />*/}

            <Screenshots className="bg-gray-100 bg-opacity-50" item={item} />
        </Layout>
    );
};

export default App;
